module.exports = __webpack_public_path__ + "static/scale-model-of-knoxville-walking-tours-in-knoxville-tennessee-13bc2ae13fdd6afeb6caff5da4587e44.png";